import { render, staticRenderFns } from "./adesao.vue?vue&type=template&id=cebccaa2"
import script from "./adesao.vue?vue&type=script&lang=js"
export * from "./adesao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports